module.exports = __webpack_public_path__ + "media/images/pic/people-9b36ee4a684a1eab8306b8d93374b940.jpg";